import VehicleLinkReducer from './vehicle_link_reducer';

export default VehicleLinkReducer;
